import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { Form, Input, Select } from 'antd';
import { VisionEntityType } from '@wellverse/shared-ts';

export const KnowledgeBaseCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({ resource: 'knowledge-bases' });

  return (
    <Create resource="knowledge-bases" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <Input placeholder="My Knowledge Base" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={3} placeholder="What this knowledge base is for..." />
        </Form.Item>
        <Form.Item label="Entity Type" name="entityType" rules={[{ required: true }]} initialValue={VisionEntityType.DISH}>
          <Select>
            {Object.values(VisionEntityType).map((t) => (
              <Select.Option key={t} value={t}>
                {t}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Create>
  );
};
